// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICipStatusMultiEmployersSummaryRecordDto } from './ICipStatusMultiEmployersSummaryRecordDto';
import {
    ICipStatusMultiEmployersSummaryRecordDtoFromJSON,
    ICipStatusMultiEmployersSummaryRecordDtoFromJSONTyped,
    ICipStatusMultiEmployersSummaryRecordDtoToJSON,
    ICipStatusMultiEmployersSummaryRecordDtoToJSONTyped,
} from './ICipStatusMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<ICipStatusMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto
     */
    subsidiary_records?: Array<ICipStatusMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(ICipStatusMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoCipStatusMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(ICipStatusMultiEmployersSummaryRecordDtoToJSON)),
    };
}

